import React, { FunctionComponent } from 'react';
import { Block, BlockContent } from 'components/elements';
import styles from './TestujLogo.module.scss';

interface OwnProps {}

type TestujLogoProps = JSX.IntrinsicElements['div'] & OwnProps;

const TestujLogo: FunctionComponent<TestujLogoProps> = props => {
  return (
    <Block id="description" data-module="description" theme="white">
      <BlockContent direction="row">
        <a
          target="_blank"
          className={styles.companyLogoWrap}
          rel="noopener noreferrer"
          href="https://testuj.pl/warsztaty-specjalistyczne-dla-zespolow-it"
        >
          <img
            data-image="testuj"
            className={styles.companyLogo}
            alt="Testuj logo"
            src="https://testarmy.com/wp-content/uploads/2023/10/logo_testuj_ciemne-2.png"
          />
        </a>
      </BlockContent>
    </Block>
  );
};

export default TestujLogo;
